"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _formatRussianNumber = _interopRequireDefault(require("./utils/formatRussianNumber.js"));

var _preventInput = _interopRequireDefault(require("./utils/preventInput.js"));

var _checkOverflow = require("./utils/checkOverflow.js");

var _findNextPosition = _interopRequireDefault(require("./utils/findNextPosition.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PhoneMask = /*#__PURE__*/function () {
  function PhoneMask(input) {
    var _this = this;

    _classCallCheck(this, PhoneMask);

    _defineProperty(this, "resultInput", void 0);

    _defineProperty(this, "cont", void 0);

    _defineProperty(this, "countryInput", void 0);

    _defineProperty(this, "phoneInput", void 0);

    _defineProperty(this, "countryLabel", void 0);

    _defineProperty(this, "phoneLabel", void 0);

    _defineProperty(this, "listeners", {
      change: []
    });

    _defineProperty(this, "initHtml", function () {
      _this.countryLabel = document.createElement('label');
      _this.countryLabel.innerHTML = '<span class="ipi-plus">+</span>';

      _this.cont.appendChild(_this.countryLabel);

      _this.countryInput = document.createElement('input');
      _this.countryInput.maxLength = 3;
      _this.countryInput.className = 'ipi-country-input';
      _this.countryInput.value = 7;

      _this.countryLabel.appendChild(_this.countryInput);

      _this.phoneLabel = document.createElement('label');

      _this.cont.appendChild(_this.phoneLabel);

      _this.phoneInput = document.createElement('input');
      _this.phoneInput.maxLength = 15;
      _this.phoneInput.className = 'ipi-phone-input';
      _this.phoneInput.type = 'tel';
      _this.phoneInput.value = (0, _formatRussianNumber["default"])(_this.resultInput.value.replace(/^\+7/, '').replace(/\D/g, ''));

      _this.phoneLabel.appendChild(_this.phoneInput);
    });

    _defineProperty(this, "on", function (event, callback) {
      if (_this.listeners[event]) _this.listeners[event].push(callback);
    });

    _defineProperty(this, "trigger", function (event, payload) {
      if (_this.listeners[event]) {
        _this.listeners[event].forEach(function (callback) {
          return callback(payload);
        });
      }
    });

    _defineProperty(this, "setPhone", function (value) {
      var filtered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _this.phoneInput.value = filtered ? (0, _formatRussianNumber["default"])(value) : value;

      _this.updateResult();

      _this.trigger('change', _this.getResultValue());
    });

    _defineProperty(this, "updateResult", function () {
      _this.resultInput.value = _this.getResultValue();
    });

    _defineProperty(this, "initMask", function () {
      _this.countryInput.addEventListener('input', _this.inputCountryHandler);

      _this.countryInput.addEventListener('blur', _this.blurCountryHandler);

      _this.countryInput.addEventListener('paste', _this.pasteHandler);

      _this.phoneInput.addEventListener('input', _this.inputPhoneHandler);

      _this.phoneInput.addEventListener('paste', _this.pasteHandler);

      _this.phoneInput.addEventListener('keydown', _this.keydownHandler);
    });

    _defineProperty(this, "blurCountryHandler", function () {
      if (!_this.countryInput.value) _this.setCountryCode(7);
    });

    _defineProperty(this, "inputCountryHandler", function () {
      _this.setCountryCode(_this.countryInput.value.replace(/\D/g, ''));
    });

    _defineProperty(this, "keydownHandler", function (e) {
      var cursorPos = _this.phoneInput.selectionStart;
      if (cursorPos !== _this.phoneInput.selectionEnd) return; // Removing - with not-numeric symbols delete next/prev number

      if (e.key === 'Backspace' && cursorPos && /\D/.test(_this.phoneInput.value[cursorPos - 1])) {
        e.preventDefault();
        var prevPos = (0, _findNextPosition["default"])(_this.phoneInput.value, cursorPos - 1, -1);

        _this.setPhone(_this.phoneInput.value.substring(0, prevPos) + _this.phoneInput.value.substring(prevPos + 1), false);

        _this.inputPhoneHandler();

        _this.phoneInput.selectionStart = _this.phoneInput.selectionEnd = prevPos;
      }

      if (e.key === 'Delete' && /\D/.test(_this.phoneInput.value[cursorPos])) {
        e.preventDefault();
        var nextPos = (0, _findNextPosition["default"])(_this.phoneInput.value, cursorPos);

        _this.setPhone(_this.phoneInput.value.substring(0, nextPos) + _this.phoneInput.value.substring(nextPos + 1), false);

        _this.inputPhoneHandler();

        _this.phoneInput.selectionStart = _this.phoneInput.selectionEnd = nextPos;
      }
    });

    _defineProperty(this, "inputPhoneHandler", function (e) {
      var numericValue = _this.phoneInput.value.replace(/\D/g, '');

      if (!numericValue) return _this.setPhone('');
      var cursorPos = _this.phoneInput.selectionStart; // Inputting in end of line - just format

      if (_this.phoneInput.value.length === cursorPos) return _this.setPhone((0, _formatRussianNumber["default"])(numericValue), false); // Prevent inputting not numeric symbols

      if (e && e.data && /\D/.test(e.data)) return (0, _preventInput["default"])(_this.phoneInput); // Fix blocks overflow

      if ((0, _checkOverflow.checkBlockOverflow)(_this.phoneInput.value, cursorPos)) {
        if ((0, _checkOverflow.checkOverflow)(_this.phoneInput.value)) return (0, _preventInput["default"])(_this.phoneInput);

        _this.setPhone((0, _formatRussianNumber["default"])(numericValue), false);

        var newPos = /\d/.test(_this.phoneInput.value[cursorPos - 1]) ? cursorPos : cursorPos + 1;
        _this.phoneInput.selectionStart = _this.phoneInput.selectionEnd = newPos;
      }
    });

    _defineProperty(this, "pasteHandler", function (e) {
      e.preventDefault();
      var pasted = e.clipboardData || window.clipboardData; // On paste - clear and set pasted value

      if (pasted) {
        e.data = pasted.getData('Text').replace(/\D/g, '');
        e.data = e.data.replace(new RegExp('^(' + _this.countryInput.value + '|8)'), '');

        _this.setPhone(e.data, false);

        _this.inputPhoneHandler(e);
      }
    });

    this.resultInput = input;
    this.cont = input.parentNode;
    this.initHtml();
    this.initMask();
  }

  _createClass(PhoneMask, [{
    key: "destroy",
    value: function destroy() {
      this.countryInput.removeEventListener('input', this.inputCountryHandler);
      this.countryInput.removeEventListener('blur', this.blurCountryHandler);
      this.countryInput.removeEventListener('paste', this.pasteHandler);
      this.phoneInput.removeEventListener('input', this.inputPhoneHandler);
      this.phoneInput.removeEventListener('paste', this.pasteHandler);
      this.phoneInput.removeEventListener('keydown', this.keydownHandler);
      this.cont.removeChild(this.countryLabel);
      this.cont.removeChild(this.phoneLabel);
      this.countryInput = this.phoneInput = this.countryLabel = this.phoneInput = null;
    }
  }, {
    key: "setCountryCode",
    value: function setCountryCode(value) {
      this.countryInput.value = value;
      this.updateResult();
      this.trigger('change', this.getResultValue());
    }
  }, {
    key: "getResultValue",
    value: function getResultValue() {
      return '+' + this.countryInput.value + ' ' + this.phoneInput.value;
    }
  }]);

  return PhoneMask;
}();

exports["default"] = PhoneMask;